// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModifiersModalHelpers__footer___3QCIJ colors__bg-accent___dRl9M"};